import Raven from 'raven-js';
import { usePurchaseableProductsForTerm } from '../../../hooks/useBulkPurchaseOptions';
import { useCurrencyCodeUnitToDisplay, useDisplayedCurrencyCode } from '../../../hooks/useCurrencies';
import SkeletonLoadWrapper from '../../common/loading/SkeletonLoadWrapper';
import { PriceDisplayStyled } from '../price-display/PriceDisplayStyled';
import { jsx as _jsx } from "react/jsx-runtime";
const HubSpotCreditsTilePrice = ({
  quantity,
  seleniumId,
  term
}) => {
  var _pricingInfo$monthly, _pricingInfo$monthly2;
  const currencyCode = useDisplayedCurrencyCode();
  const currencyCodeUnit = useCurrencyCodeUnitToDisplay();
  const {
    purchaseOptionsForTerm: pricingInfo,
    loading: pricingLoading,
    error: pricingError
  } = usePurchaseableProductsForTerm({
    apiName: 'hubspot-credits-committed',
    queryParamTerm: term
  });
  if (pricingError) {
    Raven.captureException(pricingError, {
      extra: {
        quantity,
        apiName: 'hubspot-credits-committed',
        term,
        errorMessage: 'Error fetching pricing data'
      }
    });
  }
  if (!pricingInfo) {
    return null;
  }

  // Updating the pricing info to include the quantity, specifically for the monthly price since
  // PriceDisplayStyled only pulls that value.
  const pricingInfoForQuantity = Object.assign({}, pricingInfo, {
    monthly: Object.assign({}, pricingInfo.monthly, {
      calculatedPrice: ((_pricingInfo$monthly = pricingInfo.monthly) === null || _pricingInfo$monthly === void 0 ? void 0 : _pricingInfo$monthly.calculatedPrice) * quantity,
      fullPrice: ((_pricingInfo$monthly2 = pricingInfo.monthly) === null || _pricingInfo$monthly2 === void 0 ? void 0 : _pricingInfo$monthly2.fullPrice) * quantity
    })
  });
  return /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
    isLoading: pricingLoading,
    widths: ['50%'],
    heights: [41],
    children: /*#__PURE__*/_jsx(PriceDisplayStyled, {
      pricingInfo: pricingInfoForQuantity,
      seleniumId: seleniumId,
      currencyCode: currencyCode,
      currencyCodeUnit: currencyCodeUnit
    })
  });
};
export default HubSpotCreditsTilePrice;